//Global constants

//BASE_CONFIGURATION is declared in config.js file in the public folder
//eslint-disable-next-line
const config = BASE_CONFIGURATION;

export default {
    install(Vue) {
        Vue.prototype.$coreDomain = config.coreDomain;

        // Read features lazily so BASE_CONFIGURATION is always fully loaded
        Object.defineProperty(Vue.prototype, '$features', {
            get() {
                // eslint-disable-next-line no-undef
                return (typeof BASE_CONFIGURATION !== 'undefined' ? BASE_CONFIGURATION : {}).features ?? {};
            }
        });

        //Vuetify component dimensions
        Vue.prototype.$vToolbarHeightDense = 48;
        Vue.prototype.$vToolbarMarginBottom = 12;
    }
}